export const INPUT_MAX_LENGTH = 255;
export const SCREEN_MIN_HEIGHT = 800;
export const TABLE_MIN_SIZE_HEIGHT = 430;
export const PRIVACY_POLICY_URL = "https://kentro.network/privacy-policy/";
export const TERM_OF_USE_URL = "https://kentro.network/terms-of-use/";

export const REFRESH_TOKEN_EXPIRE_TIME =
  process.env.REACT_APP_REFRESH_TOKEN_EXPIRE_TIME ?? 5; // Minute
